module.exports = __webpack_public_path__ + "static/media/energybox_logo-white.2b6e1d43.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/logos/energybox_logo-white.svg
// module id = 479
// module chunks = 0